import React from 'react';
import {
  LineChart,
  Line,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend
} from 'recharts';

const TradingChart = () => {
  // Sample data for the chart
  const data = [
    { time: '17:30', price: 4745, volume: 12 },
    { time: '17:45', price: 4748, volume: 15 },
    { time: '18:00', price: 4749, volume: 18 },
    { time: '18:15', price: 4747, volume: 14 },
    { time: '18:30', price: 4750, volume: 20 },
    { time: '18:45', price: 4749, volume: 16 },
    { time: '19:00', price: 4752, volume: 22 },
    { time: '19:15', price: 4751, volume: 19 },
    { time: '19:30', price: 4749, volume: 17 },
    { time: '19:45', price: 4750, volume: 21 },
    { time: '20:00', price: 4748, volume: 15 },
    { time: '20:15', price: 4749, volume: 13 },
    { time: '20:30', price: 4750, volume: 16 },
    { time: '20:45', price: 4749, volume: 14 },
  ];

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <ResponsiveContainer width="100%" height={350}>
        <AreaChart data={data}>
          <defs>
            <linearGradient id="colorPrice" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#d2f157" stopOpacity={0.3}/>
              <stop offset="95%" stopColor="#d2f157" stopOpacity={0}/>
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
          <XAxis dataKey="time" stroke="#999" />
          <YAxis domain={['dataMin - 10', 'dataMax + 10']} stroke="#999" />
          <Tooltip 
            contentStyle={{ 
              backgroundColor: '#fff', 
              border: 'none', 
              borderRadius: '8px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}
          />
          <Legend />
          <Area 
            type="monotone" 
            dataKey="price" 
            stroke="#0f3d2f" 
            fill="url(#colorPrice)" 
            strokeWidth={2}
            dot={{ fill: '#d2f157', strokeWidth: 2, r: 4 }}
            activeDot={{ r: 6, fill: '#0f3d2f' }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TradingChart;